import {
    createEmpty,
    createEmptyData,
    datasetKey,
} from '../../scorecard/scorecard.model';
import { User } from '../../user/user.model';
import { getScoreData } from '../my-scorecard.function';
import { ScorecardState } from '../my-scorecard.state';

import { createHistoryPosition } from './create-history-position';
import { getYourTeamEnabled } from './get-yourteam-enabled';
import { HistoryPositionNavigate } from './history-position-navigate.model';

export function navigateScorecardHistoryReducer(
    state: ScorecardState,
    historyPosNav: HistoryPositionNavigate,
    user: User,
): ScorecardState {
    try {
        // next scorecard history
        // TODO revise. may be null if data has not yet arrived
        const nextSh =
            state.scorecardHistory[state.selectedPeriodType.periodTypeId];

        let nextIndex = (state.historyPos.index ?? 0) + historyPosNav.direction;
        nextIndex = Math.min(Math.max(0, nextIndex), nextSh.length - 1);

        // next scorecard
        const nextSc = nextSh[nextIndex];
        const key = datasetKey(
            state.selectedPeriodType.periodTypeId,
            nextSc.scorecardId,
        );
        const nextSelSc = {
            header: nextSc != null ? nextSc : createEmpty(),
            data:
                state.scorecardDataset[key] != null
                    ? state.scorecardDataset[key]
                    : createEmptyData(),
        };

        const historyPos = createHistoryPosition(nextSh, nextSelSc);

        const nextYtEnabled = getYourTeamEnabled(nextSelSc);
        const scorecardData = getScoreData(nextSelSc, user);

        return {
            ...state,
            selectedScorecardHistory: nextSh,
            selectedScorecard: nextSelSc,
            historyPos,
            yourTeamEnabled: nextYtEnabled,
            scorecardData,
        };
    } catch {
        return state;
    }
}
